export enum RegiftCardStateEnum {
    CHECK_BALANCE ="CHECK_BALANCE",
    REGIFT_CARD ="REGIFT_CARD",
    ENTER_RECEPIENTS ="ENTER_RECEPIENTS",
    CUSTOMIZE_CARD="CUSTOMIZE_CARD",
    REVIEW_PAY = "REVIEW_PAY"    
}